module.exports = __webpack_public_path__ + "static/blowout-65619392007ad506e1faab6e94883066.jpg";